/**
 * mSTEM shared-with-me projects reducer (PRJ-05 / LLD UC 12).
 *
 * Read-only mock list of items shared with the current user. Seeded from
 * src/lib/mstem-mock/shared-projects.js. The reducer exposes only a
 * LOAD action so that future BE integration can swap the seed for a real
 * /shared-projects API response without changing the modal containers.
 *
 * Phase 3 prototype scope intentionally does NOT allow adding entries via
 * dispatch — sharing flow simulates server-side fan-out (mock) and the
 * shared list only grows for OTHER mock users, not this user.
 */

import MOCK_SHARED_PROJECTS from '../lib/mstem-mock/shared-projects';

const LOAD = 'scratch-gui/shared-projects/LOAD';

const initialState = {
    list: MOCK_SHARED_PROJECTS.slice()
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case LOAD:
        if (!Array.isArray(action.list)) return state;
        return Object.assign({}, state, {list: action.list.slice()});
    default:
        return state;
    }
};

const loadSharedProjects = function (list) {
    return {type: LOAD, list: list};
};

export {
    reducer as default,
    initialState as sharedProjectsInitialState,
    loadSharedProjects
};
